import { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import GreyCrop from "@/assets/icons/greyCrop.png";
import GreyRotate from "@/assets/icons/greyRotate.png";
import WhiteCrop from "@/assets/icons/whiteCrop.png";
import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import { isValidImageDataURI, convertImageToBase64UsingCanvas, convertImageToBase64UsingCanvas_v2 } from "@/utils"

import './style.css'

export default function ImageEditer(props: any) {
  const { common } = useLocalTranslation();

  const cropperRef: any = useRef(null);
  const [image, setImage] = useState<any>(null);
  const [isCropping, setIsCropping] = useState(false);
  const [imageVersion, setImageVersion] = useState(0);
  const [isImgLoaded, setIsImgLoaded] = useState(false);
  // const [imageUrl, setImageUrl] = useState<any>(null);

  useEffect(() => {
    if (props.ogImage) {
      handleUpdateOgImg(props.ogImage)
    }
  }, [props.ogImage])


  const handleUpdateOgImg = async (ogImage: any) => {
    let useThisImg = ogImage
    const isValidImageDataURI_ = isValidImageDataURI(useThisImg)    
    if (!isValidImageDataURI_) {
      useThisImg = await convertImageToBase64UsingCanvas(useThisImg)
      // useThisImg = await convertImageToBase64UsingCanvas_v2(useThisImg)    
    }
    setImage(useThisImg)
    setImageVersion((v) => v + 1);
  }


  useEffect(() => {
    createOverLayImg()
  }, [isImgLoaded])

  useEffect(() => {
    updateOverLayImgStyle(30)
  }, [imageVersion])


  const initFilePopupV2 = () => {
    props.initFilePopup()
  }

  const toggleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;
    // debugger
    if (isCropping) {
      cropper.clear();
      cropper.disable();
    } else {
      toggelOverLayImg('none');
      cropper.enable();
      cropper.crop();
    }

    setIsCropping(!isCropping);
  };



  const rotateImage = () => {
    const cropper = cropperRef.current?.cropper;
    // debugger
    if (cropper) {
      cropper.enable()
      cropper.rotate(90)
      updateOverLayImgStyle()
      const croppedDataUrl = cropper.getCroppedCanvas().toDataURL("image/png");
      setImgToParentComV2(croppedDataUrl)
    }
  };
  const disableCropper = () => {
    if (!isCropping) {
      setTimeout(() => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
          cropper.disable();
        }
      }, 100)
    }
  }

  const saveCroppedImage = () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;

    const croppedDataUrl = cropper.getCroppedCanvas().toDataURL("image/png");
    setImage(croppedDataUrl);
    setImageVersion((v) => v + 1);
    setIsCropping(false);
    setImgToParentComV2(croppedDataUrl)
    updateOverLayImgStyle()
  };

  const setImgToParentComV2 = (image_: any) => {
    props.setImgToParentCom(image_)
    // const cropper = cropperRef.current?.cropper;
    // if (cropper) {
    //   cropper.getCroppedCanvas().toBlob((blob: Blob) => {
    //     props.setImgToParentCom(blob)
    //   }, "image/jpeg", 0.8);
    // }
  };



  // ============= START : fns for overImg =============
  const createOverLayImg = () => {
    // debugger
    const newDivEle = document.getElementById('myNewDiv');

    if (!newDivEle) {
      const parentDiv = document.querySelector('.imageEditer1');
      const source = document.querySelector('.cropper-canvas');

      if (parentDiv && source) {
        // Create a new div
        const newDiv = document.createElement('div');
        newDiv.id = 'myNewDiv';
        const inlineStyle = source.getAttribute('style');

        if (inlineStyle) {
          newDiv.setAttribute('style', inlineStyle);
        }
        setSomeDefaultStyleForOverLapyImg(newDiv)

        // Set an onclick handler
        newDiv.onclick = () => {
          initFilePopupV2()
        };

        // Append the new div to the cropper-canvas
        parentDiv.appendChild(newDiv);
      } else {
        // console.log("createOverLayImg not happning")
      }
    }
  }

  const updateOverLayImgStyle = (timeout: number = 700) => {
    setTimeout(() => {
      const newDivEle = document.getElementById('myNewDiv');
      const source = document.querySelector('.cropper-canvas');
      // debugger
      if (newDivEle && source) {
        const inlineStyle = source.getAttribute('style');
        if (inlineStyle) {
          newDivEle.setAttribute('style', inlineStyle);
          setSomeDefaultStyleForOverLapyImg(newDivEle)
        }
      }
    }, timeout)
  }

  const setSomeDefaultStyleForOverLapyImg = (ele: any) => {
    ele.style.position = 'absolute';
    ele.style.opacity = '0.2';
    // ele.style.background = 'red';
    ele.style.cursor = 'pointer';
    ele.style.top = "0";
    ele.style.display = "block";
  }

  const toggelOverLayImg = (style: string) => {
    const newDivEle = document.getElementById('myNewDiv');
    if (newDivEle) {
      newDivEle.style.display = style;
    }
  }
  // ============= END : fns for overImg =============



  return (
    <div className="imageEditer">
      {/* {true && */}
      {!image &&
        <div className='animate-pulse flex items-end loader'>
          <div
            style={{
              height: props.loaderHeight ? props.loaderHeight : 300,
              width: props.loaderWidth ? props.loaderWidth : 300
            }}
            className="bg-gray-400 rounded"></div>
          <div className="loaderBtn h-[25px] w-[25px] ml-[8px] bg-gray-400 rounded-[50%] "></div>
          <div className="loaderBtn h-[25px] w-[25px] ml-[8px] bg-gray-400 rounded-[50%] "></div>
        </div>
      }
      {image && (
        <div className="imageEditer1">
          <Cropper
            key={imageVersion}
            src={image}
            style={{
              maxHeight: props.maxHeight ? props.maxHeight : 350,
              maxWidth: props.maxWidth ? props.maxWidth : 350,
              // width: '100%',
              // height: '100%',
            }}
            className="cropperCon"
            initialAspectRatio={1}
            guides={true}
            ref={cropperRef}
            rotatable={true}
            viewMode={1}
            autoCrop={false}
            background={false}
            responsive={true}
            ready={() => {
              const cropper = cropperRef.current?.cropper;
              if (cropper) {
                cropper.disable();
                cropper.reset();
                setIsImgLoaded(true)
              }
            }}
          />

          <div className="flex controlCon">
            {isCropping ? (
              <button
                className="controlCon1 flex bg-[#1573FE] text-white rounded-[100px] items-center text-[12px] h-[34px] w-[105px] justify-center mr-[5px]"
                onClick={saveCroppedImage}
              >
                <img
                  className="w-[18px] mr-[5px] cursor-pointer"
                  src={WhiteCrop} alt="WhiteCrop" />
                {common.statusText.saveCropBtn}
              </button>
            ) : (
              <img
                className="w-[36px] cursor-pointer"
                onClick={toggleCrop}
                src={GreyCrop} alt="GreyCrop" />

            )}

            {/* isCropping */}
            <button
              disabled={isCropping}
              style={{
                cursor: isCropping ? 'not-allowed' : 'pointer',
                opacity: isCropping ? 0.4 : 1
              }}
              onClick={rotateImage}
              onMouseUp={disableCropper}
              onTouchEnd={disableCropper}
            >
              <img
                className="w-[36px]"
                src={GreyRotate} alt="GreyRotate" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
